// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3-VU8","validationTips":"StatementDescriptor_validationTips__6b0yV"};